import React, { useEffect, useState } from "react";
import { Box, Chip } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IJobLocations } from "../../../../../types/campaign.types";
import TooltipCustom from "../../../../../common/components/Tooltip";
import { locationsArrayToStr } from "../../../../../utils/whatsAppUtils";
import ChipDelete from "../../../../../constants/icons/ChipDelete";
import ChevronRight from "../../../../../constants/icons/ChevronRight";

const JobLocationChips = ({
  data,
  handleRemoveChip,
  handleOpen,
  reference,
  disabled
}: {
  data: IJobLocations[];
  handleRemoveChip: (id: string) => void;
  handleOpen: () => void;
  reference: React.MutableRefObject<HTMLDivElement | null>;
  disabled:boolean
}) => {
  const [visibleChips, setVisibleChips] = useState<IJobLocations[]>([]);
  const [extraChipCounts, setExtraChipsCounts] = useState(0);

  useEffect(() => {
    const calculateVisiblePills = () => {
      let totalWidth = 0;
      let tempVisiblePills: IJobLocations[] = [];
      let overflowCount = 0;
      const inputWidth = reference.current ? reference.current.offsetWidth : 0;

      data.forEach((item) => {
        //below calculation is for the chip width. each letter takes appx. 7px and 39px is accounting the rest, like padding
        const pillWidth = 45 + 7 * item?.name?.length;
        if (totalWidth + pillWidth <= inputWidth) {
          tempVisiblePills.push(item);
          totalWidth += pillWidth;
        } else {
          overflowCount++;
        }
      });

      if (
        overflowCount &&
        tempVisiblePills.length - 1 &&
        totalWidth + 59 > inputWidth
      ) {
        overflowCount++;
        tempVisiblePills.pop();
      }
      setVisibleChips(tempVisiblePills);
      setExtraChipsCounts(overflowCount);
    };

    calculateVisiblePills();
  }, [data, reference]);

  const visibleListLabel = visibleChips?.map((item) => item.name);

  return (
    <Box sx={{ px: 1, display: "flex" }}>
      {visibleChips.map((pill) => (
        <Chip
          key={pill.id}
          label={pill.name}
          onDelete={() => {
            if (disabled) {
              return
            } else {
              handleRemoveChip(pill.id)
            }
          }}
          sx={{ 
            width: "unset",
            py: 1,
            mr: 0.5,
            "&.MuiChip-root":{
              backgroundColor: disabled ? '#FFF' : '#EAECFF',
              border: disabled ? '1px solid #E8E8EB' : '1px solid #D7D9EB',
              color:disabled ? '#D2D1D6' : '#17142A',
              padding: '6px 12px',

            },
            "& .MuiChip-label": {
              paddingLeft: '0 !important'
            }
          }}
          deleteIcon={
            <span
              style={{
                display: 'flex',
                cursor: disabled ? 'default' : 'pointer'
              }}
              onClick={() => {
                if (disabled) {
                  return
                } else {
                  handleRemoveChip(pill.id)
                }

              }}>
              <ChipDelete fill={disabled ? "#D2D1D6" : "#17142A"} />
            </span>}
        />
      ))}

      {extraChipCounts > 0 && (
        <TooltipCustom
          title={locationsArrayToStr(
            data.filter((item) => !visibleListLabel?.includes(item?.name))
          )}
          disabled={false}
        >
          <Chip
            sx={{
              zIndex: 1,
              "&.MuiChip-root":{
                backgroundColor: disabled ? '#FFF' : '#EAECFF',
                border: disabled ? '1px solid #E8E8EB' : '1px solid #D7D9EB',
                color: disabled ? '#D2D1D6' : '#17142A',
                padding: '6px 12px',

              },
              "& .MuiChip-label": {
                paddingLeft: '0 !important'
              }
            }}
            label={`${extraChipCounts} More`}
            deleteIcon={<ChevronRight fill={disabled ? "#D2D1D6" : "#17142A"} />}
            onDelete={handleOpen}
          />
        </TooltipCustom>
      )}
    </Box>
  );
};

export default React.memo(JobLocationChips);
